import schlAuthJWT from "../interfaces/schlAuthJWT";

const decodeJWT = (encodedJWT: any) => {
    let token: schlAuthJWT = <schlAuthJWT>{};
    token.header = JSON.parse(window.atob(encodedJWT.split('.')[0]));
    token.payload = JSON.parse(window.atob(encodedJWT.split('.')[1]));
    return token;
}

export default decodeJWT;